
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const OrderQuoteApi = createAsyncThunk("OrderQuote", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  // const response = await axiosInstance.get("/queryList",{ params });
  const response = await axiosInstance.get("/order_quotes",{ params });
  return response.data;
});

const OrderQuoteSlice = createSlice({
  name: "OrderQuote",
  initialState: {
    OrderQuote: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(OrderQuoteApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(OrderQuoteApi.fulfilled, (state, action) => {
        state.OrderQuote = action.payload;
        state.loading = false;
      })
      .addCase(OrderQuoteApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default OrderQuoteSlice.reducer;
